import { useState } from 'react';

/**
 * Custom hook for managing directory search and pagination state in AdminDashboard
 * 
 * @returns {Object} Object containing search and pagination state and setters
 */
export const useDirectorySearchState = () => {
    // Search states for directories
    const [userSearch, setUserSearch] = useState('');
    const [organizationSearch, setOrganizationSearch] = useState('');

    // Pagination states
    const [usersPage, setUsersPage] = useState(1);
    const [organizationsPage, setOrganizationsPage] = useState(1);
    const ITEMS_PER_PAGE = 25;

    return {
        userSearch,
        setUserSearch,
        organizationSearch,
        setOrganizationSearch,
        usersPage,
        setUsersPage,
        organizationsPage,
        setOrganizationsPage,
        ITEMS_PER_PAGE
    };
};
